import Vue from 'vue'
import Router from 'vue-router'
import $eventHub from '../components/Pages/components/eventHub'
import {isAdmin, isLoggedIn} from '../service/auth'

Vue.use(Router)
let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../components/Pages/Home')

    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/Pages/Login')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('../components/Pages/Logout')
    },
    {
      path: '/dashboard/:id',
      name: 'dashboard',
      meta: {requiredAuth: true, requiredAdmin: false, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/Dashboard')
    },
    {
      path: '/account-insights/:id',
      name: 'accountInsights',
      meta: {requiredAuth: true, requiredAdmin: false, requiredAccount: true},
      props: route => ({qPersonId: route.query.person, accountId: route.params.id}),
      component: () => import('../components/Pages/AccountInsights')
    },
    {
      path: '/account-explorer',
      name: 'accountExplorer',
      meta: {requiredAuth: true, requiredAdmin: false, requiredAccount: false},
      // props: route => ({qPersonId: route.query.person, accountId: route.params.id}),
      component: () => import('../components/Pages/AccountExplorer')
    },
    {
      path: '/account-explorer/:id',
      name: 'accountExplorerSingle',
      meta: {requiredAuth: true, requiredAdmin: false, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/AccountExplorerSingle')
    },
    {
      path: '/audience-insights/:id',
      name: 'audienceInsights',
      meta: {requiredAuth: true, requiredAdmin: false, requiredAccount: true},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/AudienceInsights')
    },
    {
      path: '/technology-landscape/:id',
      name: 'technologyLandscape',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: true},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/TechnologyLandscape')
    },
    {
      path: '/technology-insights',
      name: 'technologyInsights',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/TechnologyInsights')
    },
    {
      path: '/technology-insights/tasks',
      name: 'technologyInsightsTasks',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/TechnologyJobStatuses')
    },
    {
      path: '/technology-insights/submit-task',
      name: 'technologyInsightsSubmitTask',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/TechnologyJobSubmit')
    },
    {
      path: '/user-management/:id?',
      name: 'userManagement',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/UserManagement')
    },
    {
      path: '/admin-management',
      name: 'adminManagement',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      component: () => import('../components/Pages/AdminManagement')
    },
    {
      path: '/admin-dashboard/:id?',
      name: 'adminDashboard',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/AdminDashboard')
    },
    {
      path: '/organization-mapping/:id',
      name: 'organizationMapping',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: true},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/OrganizationMapping')
    },
    {
      path: '/material-insights-management/:id?',
      name: 'materialInsightManagement',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/MaterialInsightsManagement')
    },
    {
      path: '/general-material-insights/:id?',
      name: 'generalMaterialInsights',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/MaterialInsightsGeneral')
    },
    {
      path: '/general-management/:id?',
      name: 'generalManagement',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/GeneralManagement')
    },
    {
      path: '/account-management/:id?',
      name: 'accountManagement',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/AccountManagement')
    },
    {
      path: '/people-explorer/:id',
      name: 'peopleExplorer',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: true},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/PeopleExplorer')
    },
    {
      path: '/people-locator/:id?',
      name: 'peopleLocator',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/PeopleLocator')
    },
    {
      path: '/team-builder/:id',
      name: 'teamBuilder',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: true},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/TeamBuilder')
    },
    {
      path: '/account-dashboard/:id',
      name: 'accountDashboard',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: true},
      props: route => ({accountId: route.params.id}),
      component: () => import('../components/Pages/AccountDashboard')
    },
    {
      path: '/campaign/:id',
      name: 'campaigns',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: true},
      props: route => ({qPersonId: route.query.person, accountId: route.params.id}),
      component: () => import('../components/Pages/Campaign')
    },
    {
      path: '/admin-geo-codes',
      name: 'adminGeocodes',
      meta: {requiredAuth: true, requiredAdmin: true, requiredAccount: false},
      component: () => import('../components/Pages/AdminGeocodes')
    },
    {
      path: '*',
      name: 'notFound',
      meta: {requiredAuth: false, requiredAdmin: false, requiredAccount: false},
      component: () => import('../components/Pages/PageNotFound')
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.requiredAuth && !isLoggedIn()) {
    next('/')
    return
  }
  if (to.meta.requiredAdmin && !isAdmin()) {
    next('/')
    return
  }

  if (to.meta.requiredAccount && (!to.params || !to.params.id)) {
    next('/')
    return
  }
  // if (typeof to.matched[0].components.default === 'function') {
  $eventHub.$emit('asyncComponentLoading', to) // Start progress bar
  // }

  next()
})
router.beforeResolve((to, from, next) => {
  $eventHub.$emit('asyncComponentLoaded') // Stop progress bar
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js